export default __webpack_public_path__ + "static/media/phone.41543232.png";